import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import 'react-tabs/style/react-tabs.css';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { resetErrorMessage, apTabChanged } from '../actions/internal';
import { loadAccountPlayer, loadDashboardFilters } from '../actions/partner';
import { get } from 'lodash';
import { getTitle } from '../selectors';
import { canAddCompletedASQ, isTeacher } from '../utils/authScopes';
import { linkWithParams } from '../routes';
import { LoadingSpinner } from '../components/helpers/LoadingSpinner';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import AccountPlayerChartsContainer from './accountplayer/AccountPlayerChartsContainer';
import AccountPlayerContainer from './accountplayer/AccountPlayerContainer';
import AccountPlayerHeaderContainer from './accountplayer/AccountPlayerHeaderContainer';
import AddCompletedASQModalWrapper from './modals/AddCompletedASQModalWrapper';

class AccountPlayerPage extends React.Component {
  state = { addASQModalOpen: false };

  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadDashboardFilters({source: 'init'});
    this.props.loadAccountPlayer(this.props.match.params, {source: 'init'});
  }

  onTabSelect = tabIndex => this.setState({ tabIndex })

  handleAddASQSuccess = (newSurveyId, administrationDate) => {
    this.setState({ addASQModalOpen: false });
    this.props.push({
      pathname: linkWithParams('asq', { player_id: this.props.playerId, id: newSurveyId }),
      search: administrationDate ? `?date_finished=${administrationDate}` : '',
    });
  }
  // Reload when navigating straight from one child to another (#3209): the route changes
  // but the component stays mounted, so without this the page keeps the previous child.
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.props.resetErrorMessage();
      this.props.loadAccountPlayer(this.props.match.params, {source: 'update'});
    }
  }

  onTabSelect = tabIndex => this.setState({ tabIndex })

  render() {
    if (!this.props.auth.isAuthChecked) return null;
    const { match, playerId, playerName, title, auth } = this.props;
    const { addASQModalOpen } = this.state;
    const isLoading = playerId !== parseInt(match.params.id, 10);
    const canAddASQ = canAddCompletedASQ(auth) && !isTeacher(auth);
    const { playerBirthday, playerWeeksPremature } = this.props;
    const player = playerId ? { id: playerId, name: playerName, birthday: playerBirthday, weeksPremature: playerWeeksPremature } : null;

    return (
      <DocumentTitle title={title}>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className='row'>
            { isLoading ?
              <div className='column u-margin-top--base'>
                <LoadingSpinner bgColor='light' />
              </div> :
              <div className="column">
                <AccountPlayerHeaderContainer />
                <div className="row u-margin-top--base">
                  <AccountPlayerContainer onAddCompletedASQ={canAddASQ ? () => this.setState({ addASQModalOpen: true }) : undefined} />
                  <div className='column small-12 medium-9'>
                    <AccountPlayerChartsContainer />
                  </div>
                </div>
              </div> }
          </div>
          <AddCompletedASQModalWrapper
            open={addASQModalOpen}
            onClose={() => this.setState({ addASQModalOpen: false })}
            onSuccess={this.handleAddASQSuccess}
            playerId={playerId}
            player={player}
          />
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    playerId: get(state.accountPlayer.player, 'id', 0),
    playerName: get(state.accountPlayer.player, 'name', ''),
    playerBirthday: get(state.accountPlayer.player, 'birthday', null),
    playerWeeksPremature: get(state.accountPlayer.player, 'weeksPremature', 0),
    title: getTitle(state.accountPlayer.player, 'name'),
  }
}

AccountPlayerPage.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  playerId: PropTypes.number,
  playerName: PropTypes.string,
  title: PropTypes.string.isRequired,
  apTabChanged: PropTypes.func.isRequired,
  loadAccountPlayer: PropTypes.func.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
}

export default connect(
  mapStateToProps,
  { apTabChanged, loadAccountPlayer, loadDashboardFilters, resetErrorMessage, push }
)(AccountPlayerPage);
